<div mat-dialog-content [attr.translate]="'no'">
  <ng-container *ngIf="!showCookiesOptions; else manageCookies">
    <p>
      {{'cookieConsent' | translate }}
    </p>
    <a href="https://www.jasfbg.com.pl/polityka-prywatnosci/?cookies=0">{{'privacyPolicy' | translate }}</a>
  </ng-container>
  <ng-template #manageCookies>
    <p>
      {{'manageYourPrivacyPolicyBelow' | translate }}
    </p>
    <div class="cookie-consent-btns">
      <button mat-raised-button cdkFocusInitial class="accept-cookies-btn my-15" (click)="acceptAllCookies()">{{'acceptAll' | translate }}</button>
    </div>

    <div class="wiCookieAccordion">
      <div class="wiCookieAccordionBox" [ngClass]="{'accordionOpen': allNeededCookiesAccordion}">
        <div class="wiCookieAccordionQuestion">
          <div class="wiCookieAccordionQuestionTitle" (click)="openAccordion($event, !allNeededCookiesAccordion, false, false,false )">
            <div class="wiCookieAccordionQuestionArrow"><mat-icon>expand_more</mat-icon></div>
            {{'necessaryCookies' | translate }}
          </div>
          <div class="wiCookieAccordionQuestionTitle2">{{'alwaysActive' | translate }}</div>
        </div>
        <div class="wiCookieAccordionAnswer" style="" [style.max-height]="allNeededCookiesAccordion ? '55px' : '0px'">
          <div class="wiCookieAccordionAnswerPaddingTop"></div>
          {{'moreDetails' | translate }} <a href="https://www.jasfbg.com.pl/polityka-prywatnosci/?cookies=0" target="_blank"
                                rel="noopener">{{'privacyPolicy' | translate }}</a>
          <div class="wiCookieAccordionAnswerPaddingBottom"></div>
        </div>
      </div>

      <div class="wiCookieAccordionBox" [ngClass]="{'accordionOpen': googleAnalyticsCookiesAccordion}">
        <div class="wiCookieAccordionQuestion" >
          <div class="wiCookieAccordionQuestionTitle" (click)="openAccordion($event, false, !googleAnalyticsCookiesAccordion, false,false )">
            <div class="wiCookieAccordionQuestionArrow"><mat-icon>expand_more</mat-icon></div>
            Google Analytics
          </div>
          <mat-slide-toggle
            [(ngModel)]="googleAnalyticsCookie"
            class="slide-toggle"
           >
          </mat-slide-toggle>
        </div>
        <div class="wiCookieAccordionAnswer" style="" [style.max-height]="googleAnalyticsCookiesAccordion ? '55px' : '0px'">
          <div class="wiCookieAccordionAnswerPaddingTop"></div>
          {{'moreDetails' | translate }} <a href="https://www.jasfbg.com.pl/polityka-prywatnosci/?cookies=0" target="_blank"
                                rel="noopener">{{'privacyPolicy' | translate }}</a>
          <div class="wiCookieAccordionAnswerPaddingBottom"></div>
        </div>
      </div>

      <div class="wiCookieAccordionBox" [ngClass]="{'accordionOpen': hotjarCookiesAccordion}">
        <div class="wiCookieAccordionQuestion">
          <div class="wiCookieAccordionQuestionTitle" (click)="openAccordion($event, false, false, false,!hotjarCookiesAccordion )">
            <div class="wiCookieAccordionQuestionArrow"><mat-icon>expand_more</mat-icon></div>
            Hotjar
          </div>
          <mat-slide-toggle
            class="slide-toggle"
            [(ngModel)]="hotjarCookie"
          >
          </mat-slide-toggle>
        </div>
        <div class="wiCookieAccordionAnswer" style="" [style.max-height]="hotjarCookiesAccordion ? '55px' : '0px'">
          <div class="wiCookieAccordionAnswerPaddingTop"></div>
          {{'moreDetails' | translate }} <a href="https://www.jasfbg.com.pl/polityka-prywatnosci/?cookies=0" target="_blank"
                                rel="noopener">{{'privacyPolicy' | translate }}</a>
          <div class="wiCookieAccordionAnswerPaddingBottom"></div>
        </div>
      </div>

    </div>

  </ng-template>

</div>
<div mat-dialog-actions>
  <div class="cookie-consent-btns" *ngIf="!showCookiesOptions; else saveAndClose">
    <a (click)="showCookiesOptions = true">{{'manageCookies' | translate }}</a>
    <button mat-raised-button cdkFocusInitial class="accept-cookies-btn" (click)="acceptAllCookies()">{{'accept' | translate }}</button>
  </div>
  <ng-template #saveAndClose>
    <div class="cookie-consent-btns mt-15">
      <button mat-raised-button cdkFocusInitial class="accept-cookies-btn" (click)="setCookie()">{{'saveSettingsAndClose' | translate }}</button>
    </div>
  </ng-template>
</div>
